import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class CardLogoFilter extends Component {
    state = {
        cardTypeLists:[],
        cardTypeValue: '',
        isCardLoading: true
    };
    componentDidMount(){
        this._get_card_type(this.props.start_date,this.props.end_date);
    }
    resetCard()
    {
        this.setState({
            cardTypeValue: [],
        })
    }
    _get_card_type(start_date, end_date){
        this.setState({
            cardTypeLists:[],
            cardTypeValue: [],
            isCardLoading: true
        })
        axios.post(config.get('API_URL')+'/reports/txn-cardtype/',{
                yestSend: start_date,
                todSend: end_date,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            this.setState({
                cardTypeLists:[]
            })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((credit_debit, index) => {
                    this.state.cardTypeLists.push({value: credit_debit.card_type, label: credit_debit.card_type})
                });
            }
            this.setState({
                isCardLoading: false
            })
        });

    }


    changeCardType(optionSelected){
        let value='';
        let ceditArray = [];
        if(optionSelected.length < 1){
            value = null;
            ceditArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                ceditArray.push(mids.value)
                var index = this.state.cardTypeLists.findIndex(obj => obj.value==mids.value);
                this.state.cardTypeLists.move(index,0).join(',');
            });
        }
        this.props.onSelectCard(optionSelected, ceditArray);
        this.setState({
            cardTypeValue:optionSelected,

        });


    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="cardType"
                isMulti
                value={this.state.cardTypeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeCardType.bind(this)}
                options={this.state.cardTypeLists}
                placeholderButtonLabel="Select [Card Logo]"
                isLoading={this.state.isCardLoading}
            />
        );

    }
}
export default CardLogoFilter;